(function () {
  'use strict';

  // Update the product page price when a variant is selected from the dropdown.
  var variantSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-product-price]');
  if (variantSelect && priceEl) {
    var setPrice = function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-price');
      var compare = opt.getAttribute('data-compare-at');
      var available = opt.getAttribute('data-available') === 'true';
      if (price) {
        var html = price;
        if (compare && compare !== price) {
          html += ' <s>' + compare + '</s>';
        }
        if (!available) {
          html = price;
        }
        priceEl.innerHTML = html;
      }
    };
    variantSelect.addEventListener('change', setPrice);
  }

  document.querySelectorAll('[data-family-pack]').forEach(function (builder) {
    var required = Number(builder.getAttribute('data-required')) || 4;
    var discount = Number(builder.getAttribute('data-discount')) || 0;
    var currency = builder.getAttribute('data-currency') || 'USD';
    var lines = Array.prototype.slice.call(builder.querySelectorAll('[data-family-line]'));
    var checkout = builder.querySelector('[data-family-checkout]');
    var count = builder.querySelector('[data-family-count]');
    var status = builder.querySelector('[data-family-status]');

    var money = function (cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    };

    var update = function () {
      var quantity = lines.reduce(function (sum, line) {
        return sum + (Number(line.getAttribute('data-quantity')) || 0);
      }, 0);
      var subtotal = lines.reduce(function (sum, line) {
        var lineQuantity = Number(line.getAttribute('data-quantity')) || 0;
        return sum + lineQuantity * Number(line.getAttribute('data-price'));
      }, 0);

      lines.forEach(function (line) {
        var lineQuantity = Number(line.getAttribute('data-quantity')) || 0;
        var available = line.getAttribute('data-available') === 'true';
        line.querySelector('[data-family-quantity]').textContent = lineQuantity;
        line.querySelector('[data-family-minus]').disabled = lineQuantity === 0;
        line.querySelector('[data-family-plus]').disabled = !available || quantity >= required;
      });

      var savings = Math.round(subtotal * discount / 100);
      builder.querySelector('[data-family-regular]').textContent = money(subtotal);
      builder.querySelector('[data-family-savings]').textContent = '-' + money(savings);
      builder.querySelector('[data-family-total]').textContent = money(subtotal - savings);
      count.textContent = quantity + ' of ' + required + ' selected';
      status.textContent = quantity === required ? 'Ready for secure checkout' : 'Select exactly ' + required + ' units';
      checkout.disabled = quantity !== required;
    };

    lines.forEach(function (line) {
      line.setAttribute('data-quantity', '0');
      line.querySelector('[data-family-minus]').addEventListener('click', function () {
        var next = Math.max(0, Number(line.getAttribute('data-quantity')) - 1);
        line.setAttribute('data-quantity', String(next));
        update();
      });
      line.querySelector('[data-family-plus]').addEventListener('click', function () {
        var selected = lines.reduce(function (sum, item) {
          return sum + (Number(item.getAttribute('data-quantity')) || 0);
        }, 0);
        if (selected >= required) return;
        line.setAttribute('data-quantity', String(Number(line.getAttribute('data-quantity')) + 1));
        update();
      });
    });

    checkout.addEventListener('click', function () {
      var cartLines = lines.map(function (line) {
        var quantity = Number(line.getAttribute('data-quantity')) || 0;
        return quantity > 0 ? line.getAttribute('data-variant-id') + ':' + quantity : null;
      }).filter(Boolean);
      if (cartLines.length === 0) return;
      window.location.href = builder.getAttribute('data-cart-url') + '/' + cartLines.join(',') + '?checkout';
    });

    update();
  });
})();
